import es from './es.json'
import en from './en.json'

export default {
  es,
  en
}
